export default "__VITE_ASSET__CC2Xj0X___"